import { render } from "./DentistCards.vue?vue&type=template&id=1f128128&scoped=true"
import script from "./DentistCards.vue?vue&type=script&lang=js"
export * from "./DentistCards.vue?vue&type=script&lang=js"

import "./DentistCards.vue?vue&type=style&index=0&id=1f128128&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f128128"]])

export default __exports__